import { Component, Element, h, Host, Prop, State, Watch } from "@stencil/core";
import { StzhSocialmediastreamItemData } from "../../../index";
import MiniMasonry from "minimasonry";
import { addMediaChangeListener, media, removeMediaChangeListener } from "../../../utils/media-utils";
import { hasSlot } from "../../../utils/utils";

/**
 * @slot heading - Slot for heading (or use prop)
 */
@Component({
  tag: "stzh-socialmediastream",
  styleUrl: "stzh-socialmediastream.scss",
  scoped: true,
})
export class StzhSocialmediastream {
  @Element() element: HTMLStzhSocialmediastreamElement;

  /** Socialmediastream items */
  @Prop() items: StzhSocialmediastreamItemData[] | string = [];
  private _items: StzhSocialmediastreamItemData[] = [];

  /** Heading (or use heading slot instead) */
  @Prop() heading: string = "";

  /** Heading level */
  @Prop({ reflect: true }) headingLevel: "1" | "2" | "3" | "4" = "3";

  @State() gutterInPixel = 16;

  private masonry;

  @Watch("items")
  itemsWatcher(newValue: StzhSocialmediastreamItemData[] | string) {
    if (!newValue) {
      this._items = [];
    } else if (typeof newValue === "string") {
      try {
        this._items = JSON.parse(newValue);
      } catch (e) {
        this._items = [];
      }
    } else {
      this._items = newValue;
    }
  }

  resizeHandler = () => {
    if (media("ultra").matches) {
      this.gutterInPixel = 32;
    } else if (media("large").matches) {
      this.gutterInPixel = 24;
    } else if (media("medium").matches) {
      this.gutterInPixel = 20;
    } else if (media("small").matches) {
      this.gutterInPixel = 20;
    } else {
      this.gutterInPixel = 16;
    }
    if (this.masonry) {
      this.masonry.conf.ultimateGutter = this.gutterInPixel;
      this.masonry.conf.gutter = this.gutterInPixel;
      this.masonry.conf.gutterX = this.gutterInPixel;
      this.masonry.conf.gutterY = this.gutterInPixel;
      this.masonry.layout();
    }
  };

  private init = () => {
    this.itemsWatcher(this.items);
  };

  connectedCallback() {
    this.init();
    addMediaChangeListener(this.resizeHandler);
  }

  disconnectedCallback() {
    removeMediaChangeListener(this.resizeHandler);
  }

  componentDidLoad() {
    this.resizeHandler();
    this.masonry = new MiniMasonry({
      container: ".stzh-socialmediastream__items",
      baseWidth: 275,
      gutter: this.gutterInPixel,
      surroundingGutter: 0,
    });
  }

  render() {
    const headingSlotUsed = hasSlot(this.element, "heading");

    const classes = {
      "stzh-socialmediastream": true,
      "stzh-socialmediastream--has-heading": headingSlotUsed || !!this.heading,
    };

    return (
      <Host>
        <div class={classes}>
          <div class="stzh-socialmediastream__heading">
            {!!this.heading ? (
              <stzh-heading level={this.headingLevel}>{this.heading}</stzh-heading>
            ) : (
              <slot name="heading"></slot>
            )}
          </div>
          <div class="stzh-socialmediastream__items">
            {this._items &&
              this._items.length &&
              this._items.map(item => (
                <stzh-socialmediastream-item
                  class="stzh-socialmediastream__item"
                  item={item}
                ></stzh-socialmediastream-item>
              ))}
          </div>
        </div>
      </Host>
    );
  }
}
